export const FETCH = 'RECOMMENDATIONS/FETCH_RECOMMENDATIONS'
export const SET = 'RECOMMENDATIONS/SET_RECOMMENDATIONS'
export const SET_LOADING = 'RECOMMENDATIONS/SET_LOADING'
export const DROP_LIST = 'RECOMMENDATIONS/DROP_LIST'

export const SET_SORTING = 'RECOMMENDATIONS/SET_SORTING'
export const SET_PAGE = 'RECOMMENDATIONS/SET_PAGE'
